import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from "react-i18next";
import '../../../assets/stylesheet/desktop.css';
import '../../../assets/stylesheet/responsive.css';
import 'bootstrap/dist/css/bootstrap.css';
import leftarrow from "../../../assets/images/left-arrow.svg";

import styles from './customerRegistration.module.css';
import fileuploadpopup from "../../../assets/images/fileuploadpopup.svg";
import datecalender from "../../../assets/images/datecalender.svg"
import DatePicker3 from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Select, { components } from 'react-select';
import { useHistory } from "react-router-dom";
import { formatInputValue } from '../../../shared/helper';
import InputMask from 'react-input-mask';
import { uploadURL, NEW_URL } from '../../../constants/applicationConstants';
import { Footer } from '../../common/footer/footer';
const CustomerRegistrationJSX = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    field,
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    onDateChange,
    handleChange,
    onNextButtonClick,
    getSocialImage,
    onFileChange,
    sameError,
    imageName,
    profileImagePreviewUrl,
    imgURL,
    editMode,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const [openModal, setOpenModal] = useState(false);

  const getMuskPattern = (name) =>
    name === 'phone' ? '(999) 999 9999' : 'a9a 9a9'

  const modalStatus = (action) => {
    setOpenModal(action);
  }

  let verifyInstituteID = localStorage.getItem('VerifyInstituteID');

  // Separate fields into personal details and interests sections
  const personalFieldNames = [
    'firstName',
    'lastName',
    'email',
    'primaryContact',
    'dateOfBirth',
    'gender',
    'postalCode',
    'province',
    'city',
    'country',
    'street'
  ];

  const interestFieldNames = [
    'occupation',
    'annual_income',
    'category',
    'netWorth',
    'annualHousehold',
  ];

  const personalDetailsFields = [];
  const interestsFields = [];

  field?.forEach((item) => {
    if (item.fieldType === "text" && item.contentHeading === "Your interest and additional information") {
      // Always include the section heading text in interest section
      interestsFields.push(item);
      return;
    }

    // Handle multiple fields
    if (item.fieldType === "multiple") {
      const isPersonal = item.fields.some(f => personalFieldNames.includes(f.name));
      const isInterest = item.fields.some(f => interestFieldNames.includes(f.name));

      if (isPersonal) {
        personalDetailsFields.push(item);
      } else if (isInterest) {
        interestsFields.push(item);
      }
    }
    // Single input/select fields
    else if (personalFieldNames.includes(item.name)) {
      personalDetailsFields.push(item);
    } else if (interestFieldNames.includes(item.name)) {
      interestsFields.push(item);
    }
  });

  // Handle checkbox changes for the additional checkboxes
  const handleCheckboxChange = (checkboxName, isChecked) => {
    console.log("gggggggggggg",isChecked)
    const event = {
      target: {
        name: checkboxName,
        type: 'checkbox',
        value: isChecked
      }
    };
    onInputChangeHandler(event);
  };

  // Check if both checkboxes are checked
  const areCheckboxesChecked = () => {
    return formData.termsAndConditions && formData.privacyPolicy;
  };

  // Enhanced button disable logic
  const isSubmitButtonDisabled = () => {
    return formSubmitButtonDisable || sameError || !areCheckboxesChecked();
  };

  const renderField = (item, i) => (
    <React.Fragment key={i}>
      {item.fieldType === "input" &&
        <div>
          <div className="mb-3 input-container form-group">
            <label>{t(`${item.placeholder}`)}</label>
            {item.name === 'postalCode' ?
              <InputMask mask={getMuskPattern(item.name)} value={formData[item.name]} name={item.name} onChange={onInputChangeHandler} onBlur={onTouchHandler}>
                {(inputProps) => <input {...inputProps} type="text" className="input form-control" placeholder=" " disableUnderline />}
              </InputMask> :
              <input
                onChange={onInputChangeHandler}
                onBlur={onTouchHandler}
                required
                type={item.type}
                className={
                  item.isRequired && formError[item.name]
                    ? "input form-control  is-invalid"
                    : "input form-control"
                }
                id={item.name}
                name={item.name}
                placeholder={" "}
                maxLength={item.maxLength}
                value={formData[item.name]}
              />}

            <span className="text-danger">
              {item.isRequired &&
                formError[item.name] &&
                (formError[item.name] === "req"
                  ? t(item.error)
                  : t(item.type_error))}
            </span>
          </div>
        </div>}

      {item.fieldType === "select" &&
        <div className={`mb-4 input-container selectboxmain form-group ${formData[item.name] && `selecttransition`}`}>
          <label>{t(`${item.placeholder}`)}</label>
          <Select className={`selectbox`}
            closeMenuOnSelect={true}
            options={item?.options}
            placeholder={" "}
            onChange={(e) => handleChange(e, item)}
            components={{
              Input: (props) => {
                return <>
                  <components.Input {...props} className={"input-container form-group"} >
                    {props.children}
                  </components.Input>
                </>
              },
            }}
            value={item?.options.filter(ite => ite.value === formData[item.name])}
          />
        </div>
      }

      {item.fieldType === "multiple" &&
        <div className={`disgrid grid-${item.fields.length}`}>
          {item.fields.map((items, idx) => {
            return <React.Fragment key={idx}>
              {items.fieldType === "input" &&
                <div>
                  <div className="mb-3 input-container form-group">
                    <label>{t(`${items.placeholder}`)}</label>
                    {items.name === 'phone' || items.name === 'primaryContact' || items.name === 'secondaryContact' ?
                      <InputMask mask={getMuskPattern('phone')} value={formData[items.name]} name={items.name} onChange={onInputChangeHandler} onBlur={onTouchHandler}>
                        {(inputProps) => <input {...inputProps} type="tel" className="input form-control" placeholder=" " disableUnderline />}
                      </InputMask> :
                      <input
                        onChange={onInputChangeHandler}
                        onBlur={onTouchHandler}
                        required
                        type={items.type}
                        className={
                          items.isRequired && formError[items.name]
                            ? "input form-control  is-invalid"
                            : "input form-control"
                        }
                        id={items.name}
                        name={items.name}
                        placeholder={" "}
                        maxLength={items.maxLength}
                        value={formData[items.name]}
                      />}
 {items.showIcon && (
            <img
              src={items.icon}
              alt={`${items.name}-icon`}
             className={`${styles.imageiconform}`}
            />
          )}
                    <span className="text-danger">
                      {items.isRequired &&
                        formError[items.name] &&
                        (formError[items.name] === "req"
                          ? t(items.error)
                          : t(items.type_error))}
                    </span>
                    {items.name === 'email' || items.name === 'altEmail' ?
                      sameError ? <span className="text-danger samemailerr">Login email &amp; alternative email can't be same</span> : null : null
                    }
                  </div>
                </div>
              }
              {items.fieldType === "select" &&
                <div className={`mb-4 input-container selectboxmain form-group ${formData[items.name] && `selecttransition`}`}>
                  <label>{t(`${items.placeholder}`)}</label>
                  <Select className={`selectbox`}
                    closeMenuOnSelect={true}
                    placeholder={" "}
                    options={items?.options}
                    onChange={(e) => handleChange(e, items)}
                    value={items?.options.filter(ite => ite.value === formData[items.name])}
                    components={{
                      Input: (props) => {
                        return <>
                          <components.Input {...props} className={"mb-3 input-container form-group"} >
                            {props.children}
                          </components.Input>
                        </>
                      },
                    }}
                  />
                </div>
              }
              {items.fieldType === "date" &&
                <>
                  <DatePicker3 className="form-control" name="startDate"
                    onChange={(date) => { onDateChange(date) }}
                    inputPlaceholder="dd/mm/yyyy"
                    shouldHighlightWeekends
                    maximumDate={{
                      year: new Date().getFullYear(),
                      month: new Date().getMonth() + 1,
                      day: new Date().getDate()
                    }}
                    wrapperClassName="input-container form-group"
                    renderInput={({ ref }) => (
                      <>
                        <label>{t(`${items.placeholder}`)}</label>
                        <input
                          ref={ref}
                          placeholder=" "
                          type="text"
                          required
                          className="input form-control"
                          value={formatInputValue(formData.dateOfBirth)}
                        />
                        <span className={`${styles.dateim}`}><img src={datecalender} alt={' '} /></span>
                      </>
                    )}
                    formatInputText={() => formatInputValue(formData.dateOfIncorporation)}
                  />
                </>
              }
            </React.Fragment>
          })}
        </div>
      }

      {/* {item.fieldType === "text" &&
        <div className={`${styles.institutelogintext} ${styles.institutelogintextfullwidth} primarycontact`}>
          <h4 className="h4_style">{t(`${item.contentHeading}`)}</h4>
          <h5 className="h5_style">{t(`${item.SUBHEADING1}`)}</h5>
          <h5 className="h5_style">{t(`${item.SUBHEADING2}`)}</h5>
          <h5 className="h5_style">{t(`${item.SUBHEADING3}`)}</h5>
        </div>
      } */}

      {item.fieldType === "social" &&
        <div className="disgrid grid-2">
          {item.types.map(items =>
            <div className="input-container form-group social-control" key={items.name}>
              <label>{t("REGISTRATION.LINK")}</label>
              <input
                type="text"
                required=""
                name={items.name}
                className={
                  items.isRequired && formError[items.name]
                    ? "input form-control  is-invalid"
                    : "input form-control"
                }
                placeholder=" "
                onChange={onInputChangeHandler}
                value={formData[items.name]}
              />
              <img src={getSocialImage(items)} className="formscicon" alt={' '} />
              <span className="text-danger">
                {items.isRequired &&
                  formError[items.name] &&
                  (formError[items.name] === "req"
                    ? t(items.error)
                    : t(items.type_error))}
              </span>
            </div>
          )}
        </div>
      }

      {item.fieldType === "multiSelect" &&
        <div className="mb-4 form-group">
          <label className={`multiplaceholer ${(formData['category']?.length > 0) ? 'active' : ''}`}>{t(`${item.placeholder}`)} </label>
          <div className={`selectallinnercheckbox select-all ${styles.selectallinnercheckboxcustomer}`}>
            <ul>
              {item.options?.map((option, index) => {
                const isSelected = formData.category && Array.isArray(formData.category) &&
                  formData.category.some(cat =>
                    (cat.value || cat.institutionCategoryId) === (option.value || option.institutionCategoryId)
                  );

                return (
                  <li className={`selectinner ${option.label}`} key={index}>
                    <div className="dropdown">
                      <div className="cstick">
                        <input
                          className={`form-check-input`}
                          type="checkbox"
                          value=""
                          id={`Checkmerealestate-${option.institutionCategoryId || option.value}`}
                          checked={isSelected}
                          onChange={(e) => handleChange(e, {
                            ...item,
                            value: option.value || option.institutionCategoryId,
                            label: option.label || option.name,
                            institutionCategoryId: option.institutionCategoryId
                          })}
                        />
                      </div>
                      <div className="form-check">
                        <span className="maincheckboxicon">
                          <img src={`${NEW_URL}/${option.icon}`} alt='' />
                        </span>
                        <label
                          className="form-check-label mainchecklabel"
                          htmlFor={`Checkmerealestate-${option.institutionCategoryId || option.value}`}
                        >
                          {option.label || option.name}
                        </label>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <span className="text-danger">
            {item.isRequired &&
              formError[item.name] &&
              (formError[item.name] === "req"
                ? t(item.error)
                : t(item.type_error))}
          </span>
        </div>
      }
    </React.Fragment>
  );

  return (
    <>
      <section className="mainloginscreen customerregistrationnew">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails} d-flex`}>
              <div className="detailsleft plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => history.goBack()}>
                  <img src={leftarrow} alt={' '} />
                </div>
                <h1>{t("REGISTRATION.CUSTOMERTITLE")}</h1>
              </div>
            </div>
          </div>
          <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
              <h2 className="h2_style text-center">{t("REGISTRATION.LETUSKNOW")}</h2>
              <h6 className="h6_style text-center">{t("REGISTRATION.ENTERINFO")}</h6>
              <p className="text-center smalltext">{t("REGISTRATION.MANDATORY")} </p>
            </div>

            {/* Image Upload Section */}
            <div className={`${styles.maindiv} d-flex`}>
              <div className={`${styles.uploadlogo}`} onClick={() => modalStatus(true)}>
                {profileImagePreviewUrl ?
                  <img
                    src={profileImagePreviewUrl}
                    height="170px"
                    width="250px"
                    alt="edit profile"
                  /> :
                  editMode ?
                    <img
                      src={`${NEW_URL}/${imgURL}`}
                      height="170px"
                      width="250px"
                      alt="edit profile"
                    />
                    : t("REGISTRATION.CUSTOMERLOGO")
                }
              </div>
              {openModal &&
                <div className="logochangemodal">
                  <div>
                    <button title="Close" className="modal-close" onClick={() => modalStatus(false)}>{t("REGISTRATION.CLOSE")}</button>
                    <div className="modal-header"><h2 className="h2_style">{t("REGISTRATION.LOGOCHANGE")}</h2></div>
                    <div className="modal-body mb-4">
                      <div className="modal-body-inner">
                        <div className="button_outerlogo">
                          <div className="btn_uploadlogo"><input type="file" id="upload_filelogo" name="" onChange={onFileChange} />
                            <label htmlFor="upload_filelogo">
                              {profileImagePreviewUrl ?
                                <img
                                  src={profileImagePreviewUrl}
                                  height="170px"
                                  width="250px"
                                  alt="edit profile"
                                /> :
                                editMode ?
                                  <img
                                    src={`${uploadURL}/images${imgURL}`}
                                    height="170px"
                                    width="250px"
                                    alt="edit profile"
                                  />
                                  : <img src={fileuploadpopup} alt={' '} />
                              }
                            </label>
                          </div>
                        </div>
                        {imageName && <h6 className='text-center'>{imageName}</h6>}
                        {!(editMode || profileImagePreviewUrl) && <><h5 className="text-center h5_style">{t("REGISTRATION.UPLOADLOGOIMAGE")}</h5>
                          <p className="text-center">{t("REGISTRATION.ADDICON")}</p></>}
                      </div>
                    </div>
                    {(profileImagePreviewUrl || editMode) && <div className="modal-footer">
                      <button className="ctatwobutton widthhalf" onClick={() => modalStatus(false)}>Save</button>
                      <div className={`${styles.uploadbutton} button_outer`}>
                        <div className="btn_upload">
                          <input type="file" id="upload_file" name="" onChange={onFileChange} />
                          <label htmlFor="upload_file">{"Change Icon"}</label>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>}

              <main className={`${styles.main_full_tp}`}>
                <div className="uploadproduct">
                  <div className={`${styles.uploadbuttonouter} button_outer`}>
                    <div className={`${styles.uploadbutton} btn_upload`}>
                      <input type="file" id="upload_file" name=""
                        accept="image/png, image/gif, image/jpeg"
                        onChange={onFileChange}
                      />
                      <label className={`${styles.buttonuploadlevel}`} htmlFor="upload_file">{t("REGISTRATION.FILEUPLOADTEXT")}</label>
                    </div>
                  </div>
                </div>
                <div className={`${styles.error_msg}`}> {t("REGISTRATION.IMAGEMSG")} {t("REGISTRATION.IMAGEMSGONE")}</div>
                <div className={`${styles.error_msg}`}> {t("REGISTRATION.IMAGEMSGTWO")}</div>
              </main>
            </div>

            {/* Personal Details Card */}
            <div className={`${styles.formCard} ${styles.maindiv} ${styles.institutelogintext} ${styles.institutelogintextfullwidth}  ${styles.personalDetailsCard}`}>
              <div className={`${styles.cardHeader}`}>
                <h3 className="h3_style"><Trans i18nKey={`REGISTRATION.Personal_Details`}></Trans></h3>
                <h5><Trans i18nKey={`REGISTRATION.Personal_Details_Text1`}></Trans></h5>
              </div>
              <div className={`${styles.cardBody}`}>
                {personalDetailsFields.map((item, i) => renderField(item, i))}
              </div>
            </div>

            {/* Interests and Additional Info Card */}
            <div className={`${styles.formCard} ${styles.maindiv} ${styles.interestsCard}`}>
              <div className={`${styles.cardHeader}`}>
               <h3 className="h3_style"><Trans i18nKey={`REGISTRATION.Interest_Additional`}></Trans></h3>
               <h5><Trans i18nKey={`REGISTRATION.Interest_Additional_Text1`}></Trans></h5>
              </div>
              <div className={`${styles.cardBody}`}>
                {interestsFields.map((item, i) => renderField(item, i))}
                
                {/* Additional Checkboxes at the end of interests section */}
                <div className="mb-4 form-group">
                  <div className="form-check mb-3">
                    <input
                      className={`${styles.checkboxcustom} form-check-input`}
                      type="checkbox"
                      id="termsAndConditions"
                      name="termsAndConditions"
                      checked={formData.termsAndConditions || false}
                      onChange={(e) => handleCheckboxChange('termsAndConditions', e.target.checked)}
                    />
                    <label className={`${styles.checkmarklabel} form-check-label`} htmlFor="termsAndConditions">
                    {t("COMMON.label_1")}
                    </label>
                  </div>
                  
                  <div className="form-check mb-3">
                    <input
                      className={`${styles.checkboxcustom} form-check-input`}
                      type="checkbox"
                      id="privacyPolicy"
                      name="privacyPolicy"
                      checked={formData.privacyPolicy || false}
                      onChange={(e) => handleCheckboxChange('privacyPolicy', e.target.checked)}
                    />
                    <span class={`${styles.checkmark}`}></span>
                    <label className={`${styles.checkmarklabel} form-check-label`} htmlFor="privacyPolicy">
                    {t("COMMON.label_2")}
                    </label>

                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="d-flex align-items-center justify-content-center">
              <button 
                className={isSubmitButtonDisabled() ? 'mt-4 mb-4 mainbutton' : 'mt-4 mb-4 mainbutton'}
                disabled={isSubmitButtonDisabled()}
                onClick={() => onNextButtonClick()}
              >
                {verifyInstituteID ? 'Verify Now' : t("REGISTRATION.NEXT")}
              </button>
            </div>
          </div>
          <Footer />
        </div>
      </section>
      {console.log('Form Data:', formData)}
      {console.log('Checkboxes checked:', areCheckboxesChecked())}
    </>
  );
};

export default CustomerRegistrationJSX;